import ViewPropTypes from "../DeprecatedPropTypes/DeprecatedViewPropTypes";
export default ViewPropTypes;